// src/components/IndexPage.js
import React from "react";

import Slider from "../components/Slider";
import ContactForm from "../components/ContactForm";
import contactInfo from "../config/contactInfo";

const Feature = ({ icon, title, text }) => (
  <div className="col-12 col-md-4 mb-4">
    <div className="card border-0 shadow-sm hover-lift h-100">
      <div className="card-body text-center">
        <div className="fs-1 text-primary mb-3"><i className={icon}></i></div>
        <h5 className="card-title mb-2">{title}</h5>
        <p className="card-text text-muted small">{text}</p>
      </div>
    </div>
  </div>
);

const Project = ({ img, title, desc }) => (
  <div className="col-12 col-sm-6 col-lg-4 mb-4">
    <article className="card project-card overflow-hidden h-100">
      <div className="ratio ratio-16x9">
        <img src={img} alt={title} className="object-fit-cover" />
      </div>
      <div className="card-body">
        <h6 className="mb-1">{title}</h6>
        <p className="small text-muted mb-0">{desc}</p>
      </div>
    </article>
  </div>
);

export default function IndexPage() {
  return (
    <main className="index-page">
      {/* HERO */}
      
    <Slider />

      {/* SERVICES */}
      <section id="services" className="py-5">
        <div className="container">
          <div className="section-head text-center mb-4">
            <h2 className="fw-bold">Our Core Services</h2>
            <p className="text-muted mb-0">Crafted with expertise — delivered with care.</p>
          </div>

          <div className="row mt-4">
            <Feature
              icon="bi bi-laptop"
              title="Web Development"
              text="React, Bootstrap, and modern tech to build fast, responsive websites."
            />
            <Feature
              icon="bi bi-bug"
              title="Testing & QA"
              text="Comprehensive manual and automated testing to ensure quality."
            />
            <Feature
              icon="bi bi-gear"
              title="Maintenance & Support"
              text="Continuous improvement, updates, and 24/7 reliability."
            />
          </div>
        </div>
      </section>

      {/* PORTFOLIO */}
      <section id="portfolio" className="py-5 bg-light">
        <div className="container">
          <div className="section-head text-center mb-4">
            <h2 className="fw-bold">Recent Projects</h2>
            <p className="text-muted mb-0">A glimpse of what we've built.</p>
          </div>

          <div className="row mt-4">
            <Project
              img="https://images.unsplash.com/photo-1605902711622-cfb43c4437b5?auto=format&fit=crop&w=1200&q=80"
              title="Client Portal"
              desc="Secure dashboard for clients with real-time analytics."
            />
            <Project
              img="https://images.unsplash.com/photo-1556761175-4b46a572b786?auto=format&fit=crop&w=1200&q=80"
              title="E-commerce Store"
              desc="Custom-built shop with smooth checkout and product management."
            />
            <Project
              img="https://images.unsplash.com/photo-1522075469751-3a6694fb2f61?auto=format&fit=crop&w=1200&q=80"
              title="Business Landing"
              desc="High-converting marketing site with A/B tested layouts."
            />
          </div>

          <div className="text-center mt-3">
            <a href="#contact" className="btn btn-outline-primary rounded-pill">See More Work</a>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-5 cta-section">
        <div className="container text-center text-md-start">
          <div className="row align-items-center gy-3">
            <div className="col-md-8">
              <h3 className="fw-bold mb-1">Let’s build something amazing.</h3>
              <p className="text-muted small mb-0">
                Ready to turn your idea into reality? Get a free quote today.
              </p>
            </div>
            <div className="col-md-4 text-md-end">
              <a href="#contact" className="btn btn-lg btn-primary rounded-pill px-4">
                Request a Quote
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* CONTACT */}
      <section id="contact" className="py-5">
        <div className="container">
          <div className="row align-items-center gy-4">
            <div className="col-lg-6">
              <h4 className="fw-bold">Contact Us</h4>
              <p className="text-muted">
                Tell us about your project, and we’ll reach out within 24 hours.
              </p>
              <ul className="list-unstyled small text-muted">
                <li className="mb-2">
                  <i className="bi bi-geo-alt-fill me-2 text-primary"></i> Innsbruck, Austria
                </li>
                <li className="mb-2">
                  <i className="bi bi-envelope-fill me-2 text-primary"></i> <a href={`mailto:${contactInfo.email}`}>{contactInfo.email}</a>
                </li>
                <li className="mb-2">
                  <i className="bi bi-envelope-fill me-2 text-primary"></i> <a href={`tel:${contactInfo.phone}`}>{contactInfo.phone}</a>
                </li>
                <li className="mb-2">
                  <i className="bi bi-envelope-fill me-2 text-primary"></i> <a href={`https://wa.me/${contactInfo.whatsapp.replace(/\D/g, "")}`}>Chat on WhatsApp</a>
                </li>
                
              </ul>
            </div>
            <div className="col-lg-6">
            <ContactForm />
            </div>
          </div>
        </div>
      </section>

      
    </main>
  );
}
